import { Sprite } from 'pixi.js';

import { Shared } from '../App';
import LocalisedText from './LocalisedText';
import { Widget } from './Widget';

export class CoinCounterWidget extends Widget
{
    public base!: Sprite;
    public label!: LocalisedText;

    private _coins = 0;
    private _localisationId = '';

    constructor(localisationId = '')
    {
        super();
        this._localisationId = localisationId;
    }

    protected async build(): Promise<void>
    {
        this.base = Sprite.from(Shared.assets.getTexture('coins-small'));
        this.base.scale.set(1.5);
        this.base.anchor.set(0.5);
        this.view.addChild(this.base);

        this.label = new LocalisedText('', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 10,
            lineJoin: 'round',
            align: 'center',
            fontSize: 32,
            maxWidth: 240,
        });
        this.label.anchor.y = 0.5;
        this.label.y = 2;
        this.label.x = 40;
        this.view.addChild(this.label);
    }

    public get coins(): number
    {
        return this._coins;
    }

    public set coins(v: number)
    {
        this._coins = v;
        if (this.label) this.label.setText(this._localisationId, { v });
    }
}
